import { reactive } from 'vue'

const allowModeSwitch = import.meta.env.DEV || import.meta.env.VITE_ALLOW_MODE_SWITCH === 'true'

const storedMode = allowModeSwitch && typeof window !== 'undefined'
    ? localStorage.getItem('dev:MyWealthMode')
    : null

const MyWealthMode = storedMode !== null ? storedMode === 'true' : import.meta.env.VITE_MY_WEALTH_MODE === 'true'

export const APP = reactive({
    MyWealthMode,
    MyWealthWebsite: import.meta.env.VITE_MWI_SITE_URL,
    MyWealthPrivateWebsite: import.meta.env.VITE_MWP_SITE_URL,
    CdnBaseUrl: import.meta.env.VITE_CDN_BASE_URL,
    CdnMwiBaseUrl: import.meta.env.VITE_CDN_MWI_BASE_URL,
    CdnMwpBaseUrl: import.meta.env.VITE_CDN_MWP_BASE_URL,
    OpenBankingCallbackUrl: import.meta.env.VITE_OPEN_BANKING_CALLBACK_URL,
    ShowPaymentOptions: import.meta.env.VITE_SHOW_PAYMENT_OPTIONS == 'true',
    WordPressURL: import.meta.env.WAW_WORDPRESS_URL,
    DoBVerifyClientGroups: ["ADVISED","advised"],
    FutureTargetRetirementAgeFrom: import.meta.env?.VITE_FUTURE_TARGET_RETIREMENT_AGE_FROM ?? 55,
    FutureTargetRetirementAgeTo: import.meta.env?.VITE_FUTURE_TARGET_RETIREMENT_AGE_TO ?? 57,
    FutureTargetRetirementDate: import.meta.env?.VITE_FUTURE_TARGET_RETIREMENT_DATE ?? null,
    DefaultAccountFeeFrom: import.meta.env.VITE_DEFAULT_ACCOUNT_FEE_FROM,
    DefaultAccountFeeMaximum: import.meta.env.VITE_DEFAULT_ACCOUNT_FEE_MAXIMUM,
    SelectAccountFeeFrom: import.meta.env.VITE_SELECT_ACCOUNT_FEE_FROM,
    SelectAccountFeeMaximum: import.meta.env.VITE_SELECT_ACCOUNT_FEE_MAXIMUM,
    PensionPhoneNumber: import.meta.env.VITE_PENSION_PHONE_NUMBER,
    KycPhoneNumber: import.meta.env.VITE_KYC_PHONE_NUMBER,
    KycPendingContactEmail: import.meta.env.VITE_KYC_PENDING_CONTACT_EMAIL,
    KycConsiderContactEmail: import.meta.env.VITE_KYC_CONSIDER_CONTACT_EMAIL,
    BtClientSource: import.meta.env.VITE_BT_CLIENT_SOURCE,
    InactivityTimeoutSeconds: import.meta.env?.VITE_INACTIVITY_TIMEOUT_SECONDS ?? 300,
    PensionsFeatureEnabled: import.meta.env.VITE_PENSIONS_FEATURE_ENABLED == 'true',
    PensionsCreationEnabled: import.meta.env.VITE_PENSIONS_CREATION_ENABLED == 'true',
    MinimumRetentionPortfolioValue: import.meta.env?.VITE_MIN_RETENTION_PORTFOLIO_VALUE ?? 25,
    SignUpApi: import.meta.env?.VITE_AUTH_SIGN_UP,
    IsLocalhost: import.meta.env?.VITE_IS_LOCALHOST === 'true',
    WealthServicesPhoneNumber: import.meta.env.VITE_WEALTH_SERVICES_PHONE_NUMBER,
});

export function setMyWealthMode(value) {
    if (allowModeSwitch) {
        APP.MyWealthMode = !!value
        localStorage.setItem('dev:MyWealthMode', !!value)
    }
}

if (allowModeSwitch && typeof window !== 'undefined') {
    window.setMyWealthMode = setMyWealthMode
}